var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Triangle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.6,
    height: 6.94,
    viewBox: "0 0 8.6 6.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M8.47,6.46,5.17.52a.988.988,0,0,0-1.74,0L.13,6.46A.964.964,0,0,0,0,6.94H1L4.3,1,7.6,6.94h1A.964.964,0,0,0,8.47,6.46Z",
    fill: "#c8c8c8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.080ab44c.svg";
export { ForwardRef as ReactComponent };